import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { LoadingState } from '../../../../types/loading-state';
import { createFetchedData } from '../../../../utils/fetched-data/create-fetched-data';
import { createOrGetFetchedState } from '../../../../utils/fetched-data/create-or-get-fetched-state';
import { getCacheDuration } from '../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../utils/load-data-from-api';
import { updateObject } from '../../../../utils/object-utils';
import { salesDataDomainStore } from '../../store';
import { assignItemRelatedData } from '../../utils/items/assign-item-related-data';
import { isItemSupported } from '../../utils/items/is-item-supported';
export const loadItemByHopk = async (siteId, hopk, reloadCachedData = false) => {
    const itemsBySiteId = createOrGetItemsBySiteIdState(siteId, hopk);
    const state = createOrGetFetchedState(itemsBySiteId, hopk);
    await loadDataFromApi({
        api: () => ocapiClient.instance.v1.sales.masterData.items.getByHopkForSite(siteId, hopk),
        state,
        cacheDuration: getCacheDuration('items'),
        reloadCachedData,
        onSuccess
    });
};
const onSuccess = (response, cacheDuration) => {
    const { sellableItem, relatedData } = response;
    const { item } = relatedData;
    assignItemRelatedData(relatedData, cacheDuration);
    if (!isItemSupported(item))
        throw new Error('Item is not supported');
    const state = createOrGetFetchedState(salesDataDomainStore.data.itemsById, item.id);
    updateObject(state, createFetchedData(item, cacheDuration));
    return sellableItem;
};
const createOrGetItemsBySiteIdState = (siteId, hopk) => {
    if (!salesDataDomainStore.data.sellableItemsForSiteByHopk[siteId]) {
        runInAction(() => {
            salesDataDomainStore.data.sellableItemsForSiteByHopk[siteId] = {
                [hopk]: createFetchedData(LoadingState.NotLoaded)
            };
        });
    }
    return salesDataDomainStore.data.sellableItemsForSiteByHopk[siteId];
};
